import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class QueueNotificationService {
  private subject = new Subject<any>();
  public notificationsEnabled = false;
  private activeNotification: Notification | null = null;

  showNotification(title: string, body: string, iconUrl?: string) {
    const notificationApi = window as any;

    if (!("Notification" in notificationApi)) return;
    if (notificationApi.Notification.permission !== "granted") return;

    this.activeNotification = new Notification(title, {
      body,
      icon: iconUrl || "/assets/img/fohbluelogo.png",
    });

    this.activeNotification.onclick = () => {
      window.focus();
      this.activeNotification.close();
      this.activeNotification = null;
    };

    this.activeNotification.onclose = () => {
      this.activeNotification = null;
    };
  }

  handleQueueNotification(notification: any) {
    if (this.notificationsEnabled) {
      this.showNotification(notification.title, notification.message);
    }
    this.subject.next(notification);
  }

  listen() {
    return this.subject.asObservable();
  }
   update(reservation) {
        this.subject.next({ type: "queue-updated", reservation: reservation });
  }
}
